import { usePathname } from "next/navigation";
import { global } from "utils/pageConstants";

import Footer from "./brandRefresh/common/footer";
import NavbarComp from "./elements/navbar";

const Layout = ({
  children,
  pageContext,
  blank,
  application,
  customerCareHeader,
  showHeader = true,
  isModified = false,
  showNav = true,
  showHeaderLayout = true,
  headerClassName = "mb-14 md:mb-10",
}) => {
  const pathname = usePathname();

  const { navbar, footer, notificationBanner } = global().attributes;
  return (
    <div
      className={`flex flex-col justify-between min-h-screen ${
        pathname === "/" ? "" : ""
      } scroll-smooth bg-contain sm:bg-cover`}
    >
      {/* Aligned to the top */}
      {showHeaderLayout && (
        <div
          className={`flex-1 ${customerCareHeader ? "bg-onmoLightGrey" : ""} ${
            showHeader ? "" : "!hidden"
          } ${isModified ? headerClassName : ""}`}
        >
          <NavbarComp
            navbar={navbar}
            pageContext={pageContext}
            notificationBanner={notificationBanner}
            blank={blank}
            application={application}
            customerCareHeader={customerCareHeader}
            isModified={isModified}
            showNav={showNav}
          />
        </div>
      )}
      <div className={`${application ? "mt-[66px]" : ""}`}>
        <div className="flex flex-col">{children}</div>
      </div>

      <Footer landing footer={footer} />
    </div>
  );
};

export default Layout;
